import { render, staticRenderFns } from "./SimulatorDashboard.vue?vue&type=template&id=896e40aa&scoped=true&"
import script from "./SimulatorDashboard.vue?vue&type=script&lang=js&"
export * from "./SimulatorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorDashboard.vue?vue&type=style&index=0&id=896e40aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896e40aa",
  null
  
)

export default component.exports